'use client'

import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { type SbBlokData, storyblokEditable } from '@storyblok/react'
import { VINTAGE_SHOP_FOOTER_BLOCK } from '../vintageShop.constants'
import { VintageShopFooter } from '../VintageShopFooter/VintageShopFooter'

type FooterContent = {
  readMoreDialog?: Array<SbBlokData>
}

type Props = SbBaseBlockProps<FooterContent>

export function VintageShopFooterBlock({ blok }: Props) {
  return (
    <div {...storyblokEditable(blok)}>
      <VintageShopFooter readMoreDialog={blok.readMoreDialog} />
    </div>
  )
}

VintageShopFooterBlock.blockName = VINTAGE_SHOP_FOOTER_BLOCK
